import React from "react";

// Silver-shimmer skeleton building blocks. Use these instead of a spinner so the
// page shows its shape while loading (feels faster and less "blinky").

// A single shimmering block. Pass Tailwind sizing via className.
export const Skeleton = ({ className = "" }) => (
  <div className={`esawa-shimmer rounded-md ${className}`} />
);

// A thin silver bar that sweeps left -> right across the top of a section.
export const SweepBar = ({ className = "" }) => (
  <div className={`esawa-sweepbar ${className}`} aria-hidden="true" />
);

// A generic "card list" skeleton — a header line plus a few card rows.
export const ListSkeleton = ({ rows = 4 }) => (
  <div className="space-y-4">
    <SweepBar />
    <Skeleton className="h-6 w-1/3" />
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="bg-white dark:bg-gray-800 rounded-xl shadow p-4 flex items-center gap-4">
        <Skeleton className="h-12 w-12 rounded-full" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-4 w-2/5" />
          <Skeleton className="h-3 w-1/4" />
        </div>
        <Skeleton className="h-8 w-20 rounded-lg" />
      </div>
    ))}
  </div>
);

export default Skeleton;
